<template>
  <div
    class="flex gap-0.5 items-center"
    :class="{ 'bg-fill-brand px-1 rounded-md': isVip && !onLightSurface }"
  >
    <span
      class="text-sm font-semibold leading-tight break-good-singleline line-clamp-1"
      :class="[onLightSurface ? 'text-text' : 'text-text-on-brand', textClass]"
    >
      {{ username }}
    </span>
    <PremiumBadge
      v-if="isVip && !onLightSurface"
      class="shrink-0 simulfest:landscape:size-[2.6cqh] simulfest:portrait:size-[4cqw]"
      size="sm"
    />
  </div>
</template>

<script setup lang="ts">
import PremiumBadge from "@/components/badge/premium-badge.vue";

defineProps<{
  username: string;
  isVip?: boolean;
  textClass?: string;
  /**
   * When this badge is rendered on a LIGHT surface (the new
   * channel hero panel's MEANWHILE activity row sits on `surface-secondary`,
   * not the dark hero banner), the username must use the theme-adaptive
   * `text-text` token instead of the always-white `text-text-on-brand`, and the
   * brand-red VIP name pill (authored for the dark banner) is dropped so names
   * read as plain dark text exactly like the Figma master. Default false keeps
   * every existing dark-surface consumer (chat, leaderboard, producer controls,
   * threads, simulfest) byte-identical.
   */
  onLightSurface?: boolean;
}>();
</script>
